/**
 * Determines if delivery estimates should be shown for the selected composition.
 * @param {string} showEstimates - From dataset: "true" or "false"
 * @returns {boolean}
 */
export const isDeliveryEstimatable = showEstimates => showEstimates === "true";

export const deliveryTimeLeftInMinutes = compositionDates => {
  const getCutoffTime = new Date(compositionDates.timeleft).getTime();
  if (Number.isNaN(getCutoffTime)) return 0;
  const currentTime = Date.now();
  return Math.floor((getCutoffTime - currentTime) / 1000 / 60);
};

export const getProductProperties = product => ({
  brand: product.brand,
  category: product.adwords_category,
  name: product.name,
  product_id: product.id,
  blend: product.blend,
  business_line: product.business_line,
  collar: product.collar,
  color_group: product.color_group,
  customize: product.customize,
  cut: product.cut,
  decoration_method: product.decoration_method,
  fabric_treatment: product.fabric_treatment,
  fabric: product.fabric,
  gear: product.gear,
  material_group: product.material_group,
  material: product.material,
  pack_size: product.pack_size,
  sale_discount: product.sale_discount,
  sportgear: product.sportgear,
  sports: product.sports,
  style: product.style,
  tag: product.tag,
  thickness: product.thickness,
  treatment: product.treatment
});

export const getVariantProperties = variant => ({
  currency: variant.currency,
  price: variant.price,
  favorite: variant.favorite,
  sku: variant.sku
});

export const getDeliveryDatesFromShipments = compositionDates => {
  let minDeliverySeparate = null;
  let maxDeliverySeparate = null;
  if (compositionDates.shipments && compositionDates.shipments.length > 0) {
    minDeliverySeparate = compositionDates.shipments[0].full_date;
    maxDeliverySeparate =
      compositionDates.shipments[compositionDates.shipments.length - 1].full_date;
  }
  return { minDeliverySeparate, maxDeliverySeparate };
};

export const getCompositionReferrer = () => {
  if (window.localStorage.getItem("compositionReferrer")) {
    const referrer = window.localStorage.getItem("compositionReferrer");
    window.localStorage.removeItem("compositionReferrer");
    return referrer;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const section = window.localStorage.getItem("pdpReferrerSection") || urlParams.get("section");
  const referrer = section ? `${document.referrer}#${section}` : document.referrer;
  window.localStorage.removeItem("pdpReferrerSection");
  return referrer;
};

export const hasDirectDeliveryDateChanged = (
  previousDirectDeliveryDateText,
  { value_full: currentDirectDeliveryDate }
) =>
  currentDirectDeliveryDate ? previousDirectDeliveryDateText !== currentDirectDeliveryDate : false;
